module.exports = __webpack_public_path__ + "img/4-2-IMG_3001.0a94cafb.png";